import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SearchService } from './services';
import { SearchBarComponent, SearchButtonComponent } from './components';

@NgModule({
	imports: [CommonModule, IonicModule],
	providers: [],
	declarations: [SearchBarComponent, SearchButtonComponent],
	exports: [SearchBarComponent, SearchButtonComponent]
})
export class SearchModule {
	public static forRoot(): ModuleWithProviders<SearchModule> {
		return { ngModule: SearchModule, providers: [SearchService] };
	}
}
